module.exports = __webpack_public_path__ + "static/DSC_9352-53692e9ff09659eb1b70ed0ad748e809.jpg";